/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AutomationsInputs */

const en_nav_automations = /** @type {(inputs: Nav_AutomationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automations`)
};

const pt_br2_nav_automations = /** @type {(inputs: Nav_AutomationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automações`)
};

/**
* | output |
* | --- |
* | "Automations" |
*
* @param {Nav_AutomationsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const nav_automations = /** @type {((inputs?: Nav_AutomationsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AutomationsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_automations(inputs)
	return pt_br2_nav_automations(inputs)
});